var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":"secondary","text":"","icon":"$info"}},[_c('span',{staticClass:"text--secondary"},[_vm._v(" This quote was created for test purposes only. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }